import styled from 'styled-components'

export const Heading = styled.div`
  font-weight: ${props => props.theme.font.weight.bold};
  margin-bottom: 10px;
  margin-left: 10px;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].lg}) {
    margin-left: 0;
  }
`

export const Wrapper = styled.div`
  padding-bottom: 15px;
  overflow-x: auto;
`
